// NOTE: Please update the README.md in shared/questionnaire-engine if this is modified.
export var RenderingType;
(function (RenderingType) {
    RenderingType["web"] = "web";
    RenderingType["pdf"] = "pdf";
    RenderingType["proSummary"] = "proSummary";
    RenderingType["consumerSummary"] = "consumerSummary";
})(RenderingType || (RenderingType = {}));
